import { render } from "./OrderLabels.vue?vue&type=template&id=1f58a4b9"
import script from "./OrderLabels.vue?vue&type=script&lang=js"
export * from "./OrderLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__